import { FC } from 'react';
import { useTranslation } from 'react-i18next';

const ContentBG: FC = () => {
  const { t } = useTranslation();
  return (
    <>
      <h5>Активирахте успешно двуфакторната автентикация!</h5>
      <p>
        За да продължите с използването на системата е необходимо да поддържате двуфакторното автентикиране активно.
      </p>

      <p>
        Ако загубите или смените своето устройство, но искате да продължите да използвате системата, моля, следвайте
        стъпките по-долу:
      </p>
      <ol>
        <li>Ако изгубите своето устройство, моля, обърнете се към Вашия работодател.</li>
        <li>
          Ако искате да промените устройството, с което се автентикирате:
          <ul>
            <li>Натиснете &quot;{t('twoFA.restartBtn')}&quot;</li>
            <li>Натиснете &quot;{t('twoFA.removeBtn')}&quot;</li>
            <li>Започнете процедурата по валидиране отначало.</li>
          </ul>
        </li>
      </ol>
    </>
  );
};

export default ContentBG;
